
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://rrbpwbeafeqpsuvtbgpw.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJyYnB3YmVhZmVxcHN1dnRiZ3B3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mzk3NDAzODksImV4cCI6MjA1NTMxNjM4OX0.7Hce1cu2Bisz5WRHHzfmj72p7pKGsV5AvlF45oPDQtI";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

// Configure the Supabase client with optimal settings for session persistence
export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    storage: typeof window !== 'undefined' ? window.localStorage : undefined,
    detectSessionInUrl: true,
    flowType: 'pkce',
  },
  global: {
    headers: {
      'x-application-name': 'OGMAI',
    },
  },
  realtime: {
    params: {
      eventsPerSecond: 10,
    },
  },
});

// Function to debug the current session
export const debugCurrentSession = async () => {
  try {
    const { data, error } = await supabase.auth.getSession();
    console.log('Current session:', data.session, 'Error:', error);
    return data.session;
  } catch (err) {
    console.error('Error checking session:', err);
    return null;
  }
};

/**
 * Get the current session with error handling
 * @returns The current session or null if not authenticated
 */
export const getCurrentSession = async () => {
  try {
    const { data, error } = await supabase.auth.getSession();
    if (error) {
      console.error('Error getting session:', error.message);
      return null;
    }
    return data.session;
  } catch (err) {
    console.error('Unexpected error getting session:', err);
    return null;
  }
};

/**
 * Get the current user with error handling
 * @returns The current user or null if not authenticated
 */
export const getCurrentUser = async () => {
  try {
    const { data, error } = await supabase.auth.getUser();
    if (error) {
      console.error('Error getting user:', error.message);
      return null;
    }
    return data.user;
  } catch (err) {
    console.error('Unexpected error getting user:', err);
    return null;
  }
};

/**
 * Refreshes the session if needed
 * @returns True if session was refreshed successfully
 */
export const refreshSessionIfNeeded = async () => {
  try {
    const session = await getCurrentSession();
    if (!session) return false;
    
    // Check if session is close to expiring (within 5 minutes)
    const expiresAt = session.expires_at;
    const isExpiringSoon = expiresAt && (expiresAt * 1000 - Date.now() < 5 * 60 * 1000);
    
    if (isExpiringSoon) {
      const { data, error } = await supabase.auth.refreshSession();
      if (error) {
        console.error('Error refreshing session:', error.message);
        return false;
      }
      return !!data.session;
    }
    
    return true;
  } catch (err) {
    console.error('Error in refreshSessionIfNeeded:', err);
    return false;
  }
};

// Automatically refresh session periodically
if (typeof window !== 'undefined') {
  // Set up session refresh every 10 minutes
  setInterval(refreshSessionIfNeeded, 10 * 60 * 1000);
  
  // Also refresh on page load
  refreshSessionIfNeeded();
}
